"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntradayInterval = exports.InterdayInterval = void 0;
var historical_pricing_1 = require("./historical-pricing");
Object.defineProperty(exports, "InterdayInterval", { enumerable: true, get: function () { return historical_pricing_1.InterdayInterval; } });
Object.defineProperty(exports, "IntradayInterval", { enumerable: true, get: function () { return historical_pricing_1.IntradayInterval; } });
